import { gql } from '@apollo/client'

export const BROADSIGN_CREATION_ACCEPTANCES = gql`
  query BroadsignCreationAcceptances($broadsignCreationId: ID!) {
    broadsignCreationAcceptances(broadsignCreationId: $broadsignCreationId) {
      id
      agglomeration
      city
      building
      acceptanceStatus
      rejectionDetails
      used
      aiRecommendationDecision
      aiRecommendationReason
    }
  }
`
